var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"font-heading-2 m-bottom-xs font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._v(_vm._s(_vm.sub))])])}
var staticRenderFns = []

export { render, staticRenderFns }